import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "../styles/header.css";

function ColorSchemesExample() {
  return (
    <Navbar
      variant="dark"
      expand="md"
      className="py-3 fixed-top bg-opacity-75"
      id="navbar"
    >
      <Container>
        <Navbar.Brand href=".">L N</Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse
          id="responsive-navbar-nav"
          className="justify-content-end"
        >
          <Nav>
            <Nav.Link href="#intro" className="intro">
              Home
            </Nav.Link>
            <Nav.Link href="#about-me" className="about-me">
              About Me
            </Nav.Link>
            {/* <Nav.Link href="#services">Skills</Nav.Link> */}
            <Nav.Link href="#recent-work" className="recent-work">
              Projects
            </Nav.Link>
            <Nav.Link href="#contact-me" className="contact-me">
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default ColorSchemesExample;
